import React from 'react';
import { Row, Col, Panel, Dropdown, MenuItem, Collapse } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faCaretDown, faAngleRight, faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import ShareSVG from 'otter_icons/standalone/share.svg';

import EmptyState from 'components/project/empty_state';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';


export default class Syndication extends React.Component {
  static propTypes = {
    expand: PropTypes.bool,
    moveToTab: PropTypes.func,
    syndicationPartners: PropTypes.arrayOf(PropTypes.shape({
      image: PropTypes.string,
      name: PropTypes.string,
      lastUpdated: PropTypes.string,
      links: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired
      }))
    }))
  };

  state = {
    open: !!this.props.expand
  }

  bottomBorderClass = (index) => {
    if (index == this.props.syndicationPartners.length - 1) return '';
    if (index == this.props.syndicationPartners.length - 2) return 'border-bottom border-none-lg';
    return 'border-bottom';
  };

  toggleCollapse = () => this.setState(({ open }) => ({ open: !open }));

  jumpToSyndicationTab = (e) => {
    e.preventDefault();
    this.props.moveToTab('syndication');
  }

  renderEmptyState() {
    return (
      <div>
        <EmptyState
          imageSrc={ShareSVG}
          message="Syndication is disconnected."
          subMessage="This property is currently not syndicating. Buildout will not make any changes on any channels."
          wrapInPanel
        />
      </div>
    );
  }

  renderListingLinks(links, partnerIndex) {
    if (!links || links.length === 0) {
      return;
    }

    if (links.length === 1) {
      return (
        <a
          href={links[0].url}
          rel="noopener noreferrer"
          target="_blank"
        >
          View
        </a>
      );
    }

    const linkJSX = links.map(({ url, label }, i) => {
      return (
        <MenuItem
          href={url}
          key={i}
          rel="noopener noreferrer"
          target="_blank"
        >
          {label}
        </MenuItem>
      );
    });

    return (
      <Dropdown id={`view-syndication-${partnerIndex}`}>
        <UnstyledDropdownToggle
          bsRole="toggle"
        >
          <div>
            View <FontAwesomeIcon icon={faCaretDown}/>
          </div>
        </UnstyledDropdownToggle>
        <Dropdown.Menu className="dropdown-menu-right">
          {linkJSX}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderSyndicationPartner(partner, index) {
    return (
      <Col
        className={`row-eq-height ${this.bottomBorderClass(index)}`}
        key={partner.name}
        lg={6}
        style={{ height: '100px' }}
        xs={12}
      >
        <div>
          <img
            className="text-center"
            height="50px"
            src={partner.image}
            style={{ objectFit: 'scale-down' }} width="50px"
          />
        </div>
        <div className="grow left-buffer-md">
          <h3 className="m-0"><strong>{partner.name}</strong></h3>
          <div className="text-muted">{partner.lastUpdated}</div>
        </div>
        <div>{this.renderListingLinks(partner.links, index)}</div>
      </Col>
    );
  }

  renderSyndicationPartners() {
    return (
      <Row>
        {this.props.syndicationPartners.map((partner, i) => this.renderSyndicationPartner(partner, i))}
      </Row>
    );
  }

  renderBody() {
    if (this.props.syndicationPartners.length == 0) {
      return this.renderEmptyState();
    } else {
      return this.renderSyndicationPartners();
    }
  }

  renderHeader() {
    if (this.props.expand) {
      return (
        <div className="expanded-metrics-header">
          <h2 className="mt-0">
            All Listing Sites
          </h2>
        </div>
      );
    }

    return (
      <div className="row-eq-height clickable align-top" onClick={this.toggleCollapse}>
        <FontAwesomeIcon className="right-buffer-md" icon={this.state.open ? faAngleDown : faAngleRight} size="2x"/>
        <div className="grow">
          <h2 className="mt-0">
            Additional Listing Sites -
            <span className="text-muted"> {this.props.syndicationPartners.length} Connected Channels</span>
          </h2>
        </div>
        {this.props.moveToTab &&
          <div className="text-right text-nowrap ml-2">
            <a href="#" onClick={this.jumpToSyndicationTab}>
              <FontAwesomeIcon icon={faAngleDoubleRight}/> More
            </a>
          </div>
        }
      </div>
    );
  }

  render() {
    return (
      <Panel.Body className={`${this.props.expand ? '' : 'p-5'} syndication-metrics`}>
        {this.renderHeader()}
        <Collapse in={this.state.open}>
          {this.renderBody()}
        </Collapse>
      </Panel.Body>
    );
  }
}
